import { render, staticRenderFns } from "./OrganismDiscovery.vue?vue&type=template&id=4e8c60f6&scoped=true&"
import script from "./OrganismDiscovery.vue?vue&type=script&lang=js&"
export * from "./OrganismDiscovery.vue?vue&type=script&lang=js&"
import style0 from "./OrganismDiscovery.vue?vue&type=style&index=0&id=4e8c60f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c60f6",
  null
  
)

export default component.exports